import axios from 'axios';
import Config from '../Config/Config';

export default function fetchWhiteLabelInfo(client) {
  return axios.get(`${Config.urls.getWhiteLabelResourceUrl(client)}/data.json`);
}
